export default __webpack_public_path__ + "static/media/blanchette.5fc8056d.jpg";